export class NewRouteViewModel {
    public name: string;
    public projectId: string;
    public startDate: Date;
    public endDate: Date;
    public startTime: string;
    public endTime: string;
    public roadsegment: number;
    public interval: number;
    public route: any;
    public days: number[];
    public calculateSpectrogram: boolean;
    public calculateBudgetSpectrogram: boolean;
    public includeHistoricalData: boolean;
    public branchingAnalyse: boolean;
    constructor(json?: any) {
        if (json) {
            this.name = json.name;
            this.projectId = json.projectId;
            this.startDate = json.startDate;
            this.endDate = json.endDate;
            this.startTime = json.startTime;
            this.endTime = json.endTime;
            this.roadsegment = json.roadsegment;
            this.interval = json.interval;
            this.route = json.route;
            this.days = json.days;
            this.calculateSpectrogram = json.calculateSpectrogram;
            this.calculateBudgetSpectrogram = json.calculateBudgetSpectrogram;
            this.includeHistoricalData = json.includeHistoricalData;
            this.branchingAnalyse = json.branchingAnalyse;
        }
    }
}

export class WayPointViewModel {
    public latLng: any;
    public address: string;

    constructor();
    constructor(latlng: any, address: string);
    constructor(latlng?: any, address?: string) {
        this.latLng = latlng;
        this.address = address;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/new-route/new-route.viewModel.ts